/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedProjectConfigRequestDto } from '../../models/backend-patched-project-config-request-dto';
import { BackendProjectConfigDto } from '../../models/backend-project-config-dto';

export interface ProjectsProjectConfigPartialUpdate$Params {
  id: number;
  body?: BackendPatchedProjectConfigRequestDto;
}

export function projectsProjectConfigPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectConfigPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectConfigDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectConfigPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectConfigDto>;
    }),
  );
}

projectsProjectConfigPartialUpdate.PATH = '/api/projects/project-config/{id}/';
